// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UR2mE","right":"styles_right__-cCay"};